import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, OnDestroy } from '@angular/core';
import { S3Report, Subscription, SubscriptionsService } from '../../services/user/subscriptions.service';
import { Router } from '@angular/router';
import { DatePipe, CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { utcToCentralDisplay } from '../../utils/timezone-utils';
import { AuthContextService } from '../../services/auth-context.service';

@Component({
  selector: 'app-subscription-detail',
  standalone: true,
  imports: [DatePipe, CommonModule],
  templateUrl: './subscription-detail.component.html',
  styleUrl: './subscription-detail.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SubscriptionDetailComponent implements OnInit, OnDestroy {
  selectedSubscription: Subscription | null = null;
  reports: S3Report[] = [];
  
  private destroy$ = new Subject<void>();
  
  // set breadcrumb items
  items: { name: string; url: string }[] = [];
  

  // respond to breadcrumbSelected event
  onBreadcrumbSelected(event: Event) {
    const payload = (event as CustomEvent<{
      name: string;
      url: string;
    }>).detail;

    this.router.navigate([payload.url]);
  }

  constructor(private subscriptionService: SubscriptionsService, private router: Router, private authContextService: AuthContextService) {
    const subscriptionsUrl = this.authContextService.hasInternalAccess ? '/internal/subscriptions' : '/subscriptions';
    this.items = [
      { name: 'Home', url: this.authContextService.hasInternalAccess ? '/internal' : '/' },
      { name: 'Subscriptions', url: subscriptionsUrl }
    ];
  }

  ngOnInit() {
    this.subscriptionService.selectedSubscription$
      .pipe(takeUntil(this.destroy$))
      .subscribe(sub => {
        this.selectedSubscription = sub;
        if (sub !== null) {
        this.subscriptionService.getSubscriptionReports(sub.subscriptionId)
          .pipe(takeUntil(this.destroy$))
          .subscribe(data => {
            this.reports = this.sortAndVersion(data);
          });
        const subUri = this.subscriptionService.generateSubscriptionUriFromTitle(sub);
        this.items.push({ name: sub.title, url: `/subscription/${subUri}` })
      }
    });
  }

  onDownloadClick(storageURL: string) {
    this.subscriptionService.downloadFile(storageURL);
  }

  isReportFailed(report: S3Report): boolean {
    return report.jobStatus === 'FAILED';
  }

  sortAndVersion(reports: S3Report[]) {
    //Sort reports, by endDttm, and in descending order
    reports = reports.sort((a: S3Report, b: S3Report) => {
      return new Date(b.endDttm).getTime() - new Date(a.endDttm).getTime();
    });

    // Add version name to report
    for (let i = 0; i < reports.length; i++) {
      const version = "Version " + (reports.length - i).toString();
      reports[i].version = version;
    }
    return reports;
  }

  /**
   * Format timestamp for display in Central time
   * @param timestamp UTC timestamp from API
   * @returns Formatted string in Central time
   */
  formatTimestamp(timestamp: string): string {
    return utcToCentralDisplay(timestamp, 'full');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}